






























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

export type TStep = {
  id: string;
  text: string;
  component: string;
};

@Component({
  components: {
    // Walking
    PatientResultsWalkingGenerals: () => import('@/components/patients/results/PatientResultsWalkingGenerals.vue'),
    PatientResultsWalkingAngular: () => import('@/components/patients/results/PatientResultsWalkingAngular.vue'),
    PatientResultsWalkingDegraded: () => import('@/components/patients/results/PatientResultsWalkingDegraded.vue'),
    // Running
    ChartRunningPhaseSpeedCadenceComparison: () =>
      import('@/components/charts/running/ChartRunningPhaseSpeedCadenceComparison.vue'),
    ChartRunningPhaseSpeedCadence: () => import('@/components/charts/running/ChartRunningPhaseSpeedCadence.vue'),
    ChartRunningPhaseComparisonTable: () => import('@/components/charts/running/ChartRunningPhaseComparisonTable.vue'),
  },
})
export default class PagePatientResultsComparison extends Vue {
  @Prop({ required: true }) private patient!: TPatient;

  firstAcquisition: any = null;
  secondAcquisition: any = null;

  get acquisitions() {
    return this.patient.acquisitions;
  }
  get filterAcquisitions() {
    return this.firstAcquisition
      ? this.acquisitions.filter(
          (x: any) => x.analysisType === this.firstAcquisition.analysisType && x._id !== this.firstAcquisition._id,
        )
      : [];
  }
  get walkingComponents(): TStep[] {
    return [
      {
        id: 'global',
        text: '',
        component: 'PatientResultsWalkingGenerals',
      },
      {
        id: 'advanced',
        text: '',
        component: 'PatientResultsWalkingAngular',
      },
    ];
  }
  get validSegments() {
    if (this.firstAcquisition && this.secondAcquisition && this.firstAcquisition.analysisType === 'podorun') {
      const segmentsFirstAcquisition = this.firstAcquisition.computed_data.segments.filter(
        (x: any) =>
          x.left.result.aggregates.contact_time.avg !== 0 &&
          x.right.result.aggregates.contact_time.avg !== 0 &&
          this.firstAcquisition.computed_data.aggregates.left.percent_flight_time,
      );
      const segmentsSecondAcquisition = this.secondAcquisition.computed_data.segments.filter(
        (x: any) =>
          x.left.result.aggregates.contact_time.avg !== 0 &&
          x.right.result.aggregates.contact_time.avg !== 0 &&
          this.secondAcquisition.computed_data.aggregates.left.percent_flight_time,
      );
      return !segmentsFirstAcquisition.length && !segmentsSecondAcquisition.length;
    } else {
      return false;
    }
  }
  get isDegradedActivity() {
    const walkingType = this.secondAcquisition && this.firstAcquisition?.analysisType === 'podosmart';
    return (
      walkingType &&
      (this.$pdc.helper?.isDegradedActivity(this.secondAcquisition) ||
        this.$pdc.helper?.isDegradedActivity(this.firstAcquisition))
    );
  }

  @Watch('firstAcquisition', { deep: true })
  onFirstAcquisitionSelectedChange() {
    this.secondAcquisition = null;
  }

  @Watch('secondAcquisition', { deep: true })
  onSecondAcquisitionSelected(val: any) {
    // Analytics
    if (val) {
      this.$pdc.analytics?.actions.trackSuccess('Analysis Compared', {
        patientId: this.patient._id,
        acquisitionId: this.firstAcquisition._id,
        date1: this.firstAcquisition.createdAt,
        date2: this.secondAcquisition.createdAt,
      });
    }
  }

  isNewAnalysis(acquisition: TAcquisition) {
    return this.$pdc.helper?.isNewAnalysis(acquisition.computed_data);
  }

  findByType(val: any, type: string) {
    if (type === 'icon') {
      switch (true) {
        case val.analysisType === 'podosmart':
          return '$vuetify.walking--r';
        default:
          return '$vuetify.running--r';
      }
    } else if (type === 'color') {
      switch (true) {
        case val.analysisType === 'podosmart' && this.$pdc.helper?.isDegradedActivity(val):
          return 'warning';
        case val.analysisType === 'podosmart':
          return 'accent';
        default:
          return 'success';
      }
    } else {
      switch (true) {
        case val.analysisType === 'podosmart':
          return 'walk';
        default:
          return 'run';
      }
    }
  }

  mounted() {
    this.firstAcquisition = this.acquisitions.find((x: any) => x._id === this.$route.params.acquisitionCompareId);
  }
}
